// import './App.css';
import { useEffect, useState } from 'react';
import { getAssessmentSection, createAssessmentSection, updateAssessmentSection } from './../services/api';
import QuestionsTable from '../components/questionsTable';
import { useParams } from 'react-router-dom'
import {
    makeStyles, FormControl, InputLabel, Select, MenuItem, TextField, Button
} from '@material-ui/core';

function AssessmentSection({ }) {
    let { assessmentSectionId } = useParams();
    const [assessmentSection, setAssessmentSection] = useState(null)
    const [loading, setLoading] = useState(true);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [order, setOrder] = useState("");

    const classes = {};

    useEffect(() => {
        if(assessmentSectionId) {
            getAssessmentSection(assessmentSectionId).then((res) => {
                setAssessmentSection(res);
                setLoading(false);
                setTitle(res.assessmentSectionTRs[0].section_title);
                setDescription(res.assessmentSectionTRs[0].section_description);
                setOrder(res.order);
            });
        } else {

        }
    }, []);

    const handleFieldChange = (setFunction) => {
        return (event) => {
            setFunction(event.target.value);
        }
    };

    const cancel = () => {
        setTitle(assessmentSection.assessmentSectionTRs[0].section_title);
        setDescription(assessmentSection.assessmentSectionTRs[0].section_description);
        setOrder(assessmentSection.order);
    }

    const saveChanges = () => {
        assessmentSection.assessmentSectionTRs[0].section_title = title;
        assessmentSection.assessmentSectionTRs[0].section_description = description;
        assessmentSection.order = order;
        if(assessmentSection.id) {
            updateAssessmentSection(assessmentSection);
        } else {
            createAssessmentSection(assessmentSection);
        }
    }

    function renderAssessmentSectionForm() {
        return <div>
            <div className={classes.container}>
                <FormControl className={classes.formControl}>
                    <TextField
                        label="title"
                        value={title}
                        onChange={handleFieldChange(setTitle)}
                        className={classes.formTextField}
                    />
                    <TextField
                        label="description"
                        value={description}
                        onChange={handleFieldChange(setDescription)}
                        className={classes.formTextField}
                    />
                    <TextField
                        label="order"
                        value={order}
                        onChange={handleFieldChange(setOrder)}
                        className={classes.formTextField}
                    />
                </FormControl>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={saveChanges}
                >
                    Save
                </Button>
            </div>
        </div>
    }

    return (
        <div>
            <header className="App-header2">
                Assessment Section
            </header>
            {
                loading ?
                    <span>loading...</span> :
                    <>
                        {renderAssessmentSectionForm()}
                        <QuestionsTable questions={assessmentSection.questions} assessmentSectionId={assessmentSectionId}></QuestionsTable>
                    </>
            }

        </div>
    );
}

export default AssessmentSection;
